<template>
    <el-date-picker size="small"
      v-model="timeRange"
      :type="dataTime?'datetimerange':'daterange'" 
      :clearable="true"
      :disabled='disabled'
      :default-time="['00:00:00', '23:59:59']"
      range-separator="至"
      unlink-panels
      :start-placeholder="placeholder.start"
      :end-placeholder="placeholder.end" 
      :picker-options="isAfter?pickerOptionsAfter:pickerOptions">
    </el-date-picker>
</template>

<script>
  export default {
  	name: 'datetimeRange',
    data() {
      return {
        timeRange: [],
        dataTime: false,
        isAfter: false,
        placeholder: {
          start: '开始日期',
          end: '结束日期'
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        pickerOptionsAfter: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    props: {
      defaultType: Boolean, //true含日期时间
      defaultAfter: Boolean,  //快捷菜单是之前还是之后
      defaultTime: Array, //默认时间
      defaultPlaceholder: Object,  //默认placeholder
      disabled: {
        type: Boolean,
        default: () => false
      }
    },
  	computed: {
  		getTime() {
  			let time = {}
            if(this.dataTime){
              //含日期和时间
              time.startTimeParse = this.timeRange&&this.timeRange.length
                ?(this.timeRange
                  ?this.$moment(this.timeRange[0])
                    .format('YYYY-MM-DD HH:mm:ss')
                  :'')
                :''
              time.endTimeParse = this.timeRange&&this.timeRange.length
                ?(this.timeRange
                  ?this.$moment(this.timeRange[1])
                    .format('YYYY-MM-DD HH:mm:ss')
                  :'')
                :''
            }else{
              //只含日期
              time.startTimeParse = this.timeRange&&this.timeRange.length
                ?(this.timeRange
                  ?this.$moment(this.timeRange[0])
                    .format('YYYY-MM-DD 00:00:00')
                  :'')
                :''
              time.endTimeParse = this.timeRange&&this.timeRange.length
                ?(this.timeRange
                  ?this.$moment(this.timeRange[1])
                    .format('YYYY-MM-DD 23:59:59')
                  :'')
                :''
            }
  			return time
  		},
	},
    watch: {
        defaultTime(oldVal,newVal) {
            // 默认时间不为空
            if(this.defaultTime&&this.defaultTime.length!=0){
                this.defaultTime[0] = this.$moment(this.defaultTime[0])
                  .format('YYYY-MM-DD HH:mm:ss')
                this.defaultTime[1] = this.$moment(this.defaultTime[1])
                  .format('YYYY-MM-DD HH:mm:ss')
            }
            this.timeRange = this.defaultTime ? this.defaultTime : []
        }
    },
    mounted () {
        this.dataTime = this.defaultType?true:false
        this.isAfter = this.defaultAfter?true:false
        this.defaultPlaceholder
          ?this.placeholder = this.defaultPlaceholder
          :''
        // 默认时间不为空
        if(this.defaultTime&&this.defaultTime.length!=0){
            this.defaultTime[0] = this.$moment(this.defaultTime[0])
              .format('YYYY-MM-DD HH:mm:ss')
            this.defaultTime[1] = this.$moment(this.defaultTime[1])
              .format('YYYY-MM-DD HH:mm:ss')
        }
        this.timeRange = this.defaultTime ? this.defaultTime : []
    },
    methods: {
        init() {
          this.timeRange = this.defaultTime?this.defaultTime:[]
        },
        setStartTime(val) {
          this.timeRange[0] = val
          this.getTime.startTimeParse = val
        },
        setEndTime(val) {
          this.timeRange[1] = val
          this.getTime.endTimeParse = val
        },
        setTime(arry) {
          this.timeRange = arry
          this.getTime.startTimeParse = arry[0]
          this.getTime.endTimeParse = arry[1]
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/datetimeRange.vue